
<template>
  <div>
    <div
      class="advantagelist banner-wrap"
      style="margin-top: 84px"
      ref="Cardwrap"
      @mousemove="cardmove(...arguments)"
      @mouseleave="mousecard"
    >
      <div style="width: 80%; max-width: 1377px; margin: 0 auto">
        <div
          style="width: 100%; margin-bottom: 45px; position: relative"
          class="count_center"
        >
          <!-- <img src="../../../assets/indexImg/advantages.png" alt="" /> -->
        </div>
        <div class="weAllwrap">
          123123
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  props: {
    THFdata: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      currentScroll: 0,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      rotateY: "",
      rotateY: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleScroll() {
      this.currentScroll = window.pageYOffset;
      if (this.currentScroll >= this.$refs.Cardwrap.offsetTop - 450) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = true;
      }
    },
    cardmove(e) {
      // let centerX =this.$refs.banner.offsetLeft + this.$refs.banner.offsetWidth / 2;
      // let centerY =this.$refs.banner.offsetTop + this.$refs.banner.offsetHeight / 2;
      // let deltaX = e.pageX - centerX;
      // let deltaY = e.pageY - centerY;
      // let percentageX = deltaX / centerX;
      // let percentageY = deltaY / centerY;
      // let deg =2;
      // this.rotateX = percentageY * -deg;
      // this.rotateY = percentageX * deg;
      // this.$refs.banner.style.transform = 'rotateX(' + percentageY * -deg + 'deg)' + 'rotateY(' + percentageX * deg + 'deg)';
      // this.$refs.banner.style.transform ="rotateY(" + percentageX * deg + "deg)";
    },
    mousecard() {
      // this.$refs.banner.style.transform = "";
    },
    addEventListener() {
      window.addEventListener("scroll", this.handleScroll);
    },
  },
  created() {},
  mounted() {
    this.addEventListener(); //监听滚动
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
.cardItem {
  position: relative;
  width: 100%;
  height: 100%;
  float: left;
  border-radius: 15px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
.bgText {
  padding: 20px;
}
.bgText p {
  background: #FF4D01;
  display: inline-block;
  padding: 5px;
  box-sizing: border-box;
  font-size: 16px;
  color: #ffffff;
}
.Vanbg {
  position: absolute;
  bottom: 0;
  z-index: 99;
  padding: 20px 10px;
  box-sizing: border-box;
  text-align: right;
  color: #ffffff;
  transition: all 0.6s;
}
.cardbg1 {
  background: url("../../../assets/indexImg/advantageBG1.png") no-repeat;
  background-size: 100%;
}
.cardbg2 {
  background: url("../../../assets/indexImg/advantageBG2.png") no-repeat;
  background-size: 100%;
}
.cardbg3 {
  background: url("../../../assets/indexImg/advantageBG3.png") no-repeat;
  background-size: 100%;
}
.cardbg4 {
  background: url("../../../assets/indexImg/advantageBG4.png") no-repeat;
  background-size: 100%;
}
.cardbg5 {
  background: url("../../../assets/indexImg/advantageBG5.png") no-repeat;
  background-size: 100%;
}
.wraoSon {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  transition: all 0.6s;
}
.wraoSon img {
  width: 100%;
  transition: all 0.6s;
}
.disNone {
  display: none;
}
.advantagelist {
  float: left;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 132px;
}
.weAllwrap {
  width: 100%;
  float: left;
}
.wrapItem {
  width: 20%;
  height: 536px;
  float: left;
  background: #ffffff;
  padding: 0 10px;
  box-sizing: border-box;
  transition: all 0.6s;
  overflow: hidden;
  cursor: pointer;
  border-radius: 15px;
}
.wrapItem >>> .el-card {
  border: none;
}
.wrapItem:hover {
  transform: scale(1.05);
}
.wrapItem:hover .wraoSon img {
  transform: translatey(50px);
}
.wrapItem:hover .Vanbg {
  transform: translatey(-80px);
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
.banner-wrap {
  perspective: 1000px;
}
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/placeindexInfo/Weadvantage.vue